import React, { FunctionComponent, useMemo } from 'react';
import { useParams, useNavigate, Link } from "react-router-dom";
import { useMediaQuery } from 'react-responsive';
import { useSelector } from 'react-redux';

import { Collection, RootStore } from '../app/types';
import logo from '../images/logo.svg';

export const CollectionHeader: FunctionComponent = () => {
    const navigate = useNavigate();
    const { collectionID } = useParams();
    const collectionIdNum = parseInt(collectionID);
    const isMinWidth = useMediaQuery({ minWidth: 600 });

    const appName = useSelector((state: RootStore) => state.appName);
    const collections = useSelector((state: RootStore) => state.collections);

    const collection = useMemo(() =>
        collections.find((c: Collection) => c.ID === collectionIdNum) ?? null,
        [collections, collectionIdNum]
    );

    return (
        <header
            style={{
                backgroundColor: '#2d2d2d',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '0 16px',
                minHeight: 64,
            }}
        >
            {/* Left: Logo and App Name */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <img
                    src={logo}
                    alt="logo"
                    onClick={() => navigate('/')}
                    style={{
                        height: 48,
                        width: 48,
                        cursor: 'pointer',
                        borderRadius: 8,
                    }}
                />
                {isMinWidth && (
                    <Link
                        to="/"
                        style={{
                            color: '#e0e0e0',
                            fontSize: '1.25rem',
                            fontWeight: 500,
                            textDecoration: 'none',
                        }}
                    >
                        {appName}
                    </Link>
                )}
            </div>

            {/* Right: Collection Name */}
            <div
                style={{
                    color: '#e0e0e0',
                    fontSize: isMinWidth ? '1.25rem' : '1rem',
                    fontWeight: 500,
                }}
            >
                {collection?.name}
            </div>
        </header>
    );
}
